import React from 'react';
import { Transition } from '@headlessui/react'
import { classNames } from '../../../Services/helpers';
import AlertBadge from '../../Icons/AlertBadge';
import Badge from '../../Badge/Badge';
import { useAccordionContext } from './Accordion';
import clsx from 'clsx'

const Inner = ({children}) => {
    const {
        showInfoBadges, showWarningBadges, showErrorBadges,
        openPanel, panelInfo, panelWarnings, panelErrors, firstRender, selectPanel
    } = useAccordionContext();

    return <>
        {children.map((panel, index) => {
            const isOpen = openPanel === index;
            const isFirst = (index === 0) || (openPanel !== null && index === openPanel + 1);
            const isLast = (index === children.length - 1) || (openPanel !== null && index === openPanel - 1);

            return <div key={index}
                className={classNames(
                    isOpen && 'rounded-md border my-2',
                    'border-l border-r',
                    isFirst && 'border-t rounded-t-md',
                    (!isFirst && !isOpen) && 'border-t -mt-px',
                    isLast && 'border-b rounded-b-md',
                )}
            >
                <button onClick={(e) => selectPanel(e, index, isOpen)}
                    className={classNames(
                        'w-full p-2 flex flex-row hover:bg-slate-100',
                        isOpen && 'bg-slate-100 text-brand font-bold',
                        !isOpen && 'hover:text-brand',
                    )}
                >
                    <span className="grow text-left">{panel.props.title}</span>
                    <span className="flex flex-row gap-2">
                        {showInfoBadges && <PanelBadge title={panel.props.title} data={panelInfo} theme="info" />}
                        {showWarningBadges && <PanelBadge title={panel.props.title} data={panelWarnings} theme="warning" />}
                        {showErrorBadges && <PanelBadge title={panel.props.title} data={panelErrors} theme="danger" />}

                        <AlertBadge icon={isOpen ? 'UpChevron' : 'DownChevron'}
                            size="small"
                            theme={isOpen ? 'brand' : 'info'}
                        />
                    </span>
                </button>

                <Transition
                    show={isOpen}
                >
                    <div className={clsx(
                        // Base styles
                        'transition ease-in-out transition-[max-height] transition-opacity duration-500 overflow-hidden max-h-[1000px]',
                        // Shared closed styles
                        'data-[closed]:opacity-0 data-[closed]:max-h-0',
                    )}>
                        {panel}
                    </div>
                </Transition>
                {/* This is a filthy hack to make sure form fields render at least once to update the badges */}
                {(!isOpen && firstRender) && <div className="hidden">{panel}</div>}
            </div>
        })}
    </>
}

const PanelBadge = ({title, data, theme}) => {
    if (!data[title]) {
        return null;
    }

    return <Badge theme={theme} title={data[title]} />
}

export default Inner;